// Small shared helpers for the sim: ids, logging, bus notifications, cash bookkeeping.
import { emit } from '../core/bus.js';

export const clamp = (x, lo, hi) => (x < lo ? lo : x > hi ? hi : x);
export const lerp = (a, b, t) => a + (b - a) * t;

export function nextId(state, prefix) {
  return `${prefix}${state.nextId++}`;
}

export function log(state, text, level = 'info', extra = {}) {
  state.log.push({ day: state.day, text, level, ...extra });
  if (state.log.length > 600) state.log.splice(0, state.log.length - 500);
}

// Emit a bus event (and log it). payload.pause → main loop auto-pauses.
export function notify(state, type, payload = {}) {
  const p = { day: state.day, ...payload };
  if (p.text) log(state, p.text, p.level ?? (p.pause ? 'major' : 'info'), pick(p, ['wellId', 'fieldId']));
  try { emit(type, p); } catch (e) { /* UI handler errors must never break the sim */ if (typeof console !== 'undefined') console.error(e); }
}

function pick(o, keys) {
  const r = {};
  for (const k of keys) if (o[k] !== undefined) r[k] = o[k];
  return r;
}

// P&L categories: revenue, royalties, wages, fuel, consumables, transport, interest, opex, leases, capex, other
export function book(state, cat, amount) {
  const m = state.finance.current;
  m[cat] = (m[cat] ?? 0) + amount;
}

// Spend cash (positive amount) and record it under a P&L category. Returns false if not affordable (when check=true).
export function spend(state, amount, cat = 'other', check = true) {
  if (check && amount > state.company.cash + 1e-9) return false;
  state.company.cash -= amount;
  book(state, cat, amount);
  return true;
}

export function earn(state, amount, cat = 'revenue') {
  state.company.cash += amount;
  book(state, cat, amount);
}

// Number#toLocaleString builds a formatter per call (slow, and fmt$ runs in hot notify paths); a cached
// Intl.NumberFormat with the same locale & options produces the identical string.
const US_INT = new Intl.NumberFormat('en-US');
export const fmt$ = (n) => (Math.abs(n) >= 100 ? `$${US_INT.format(Math.round(n))}` : `$${n.toFixed(2)}`);
